import { customToast } from ".";
import { client_EB_api } from "../graphql/client";
import {
  GET_MANY_PDFS,
  downloadXML as queryXML,
  downloadRespXML,
} from "../graphql";
import { downloadBase64File, downloadFile } from "./helpers";
import { ElectronicBillErrors } from "../Enums/Errors";

export async function downloadPDF(
  pdfId: string | number,
  placeId: string | number,
): Promise<void> {
  if (!pdfId) {
    customToast.error("No se encontró el archivo");
    return;
  }

  try {
    const { data } = await client_EB_api.query({
      query: GET_MANY_PDFS,
      variables: {
        ids: [pdfId],
        place_id: placeId,
      },
    });

    if (!data?.downloadManyPDF[0]) {
      customToast.error("No se encontró el archivo");
      return;
    }

    const { payload, params, type, error } = data.downloadManyPDF[0];

    if (payload) {
      downloadBase64File(payload, `${params[0]}.${type}`);
      return;
    }

    if (error === ElectronicBillErrors.NOT_FOUND) {
      customToast.error("El archivo no se encontró");
      return;
    }

    customToast.error("Error desconocido");
  } catch (error) {
    customToast.error("Error al descargar el archivo");
  }
}

export async function downloadPDFs(
  pdfIds: string[],
  placeId: string | number,
): Promise<void> {
  try {
    const { data } = await client_EB_api.query({
      query: GET_MANY_PDFS,
      variables: {
        ids: pdfIds,
        place_id: placeId,
      },
    });

    if (!data?.downloadManyPDF[0]) {
      customToast.error("No se encontró el archivo");
      return;
    }

    const { payload, params, type, error } = data.downloadManyPDF[0];

    if (payload) {
      downloadBase64File(payload, `${params[0]}.${type}`);
      return;
    }

    if (error === ElectronicBillErrors.NOT_FOUND) {
      customToast.error("El archivo no se encontró");
      return;
    }

    customToast.error("Error desconocido");
  } catch (error) {
    customToast.error("Error al descargar el archivo");
  }
}

export async function downloadXML(
  xmlIds: string,
  placeId: string | number,
  respuesta: boolean,
): Promise<void> {
  if (!xmlIds || !placeId) {
    customToast.error("falta de datos necesarios");
    return;
  }

  try {
    const { data } = await client_EB_api.query({
      query: respuesta ? downloadRespXML : queryXML,
      variables: {
        id: xmlIds,
        place_id: placeId,
      },
    });
    if (!data?.downloadManyPDF[0]) {
      customToast.error("No se encontró el archivo");
      return;
    }

    const { payload, params, type, error } = data.downloadManyPDF[0];

    if (payload) {
      downloadBase64File(payload, `${params[0]}.${type}`);
      return;
    }

    if (error === ElectronicBillErrors.NOT_FOUND) {
      customToast.error("El archivo no se encontró");
      return;
    }

    customToast.error("Error desconocido");
  } catch (error) {
    customToast.error("Error al descargar el archivo");
  }
}
export async function downloadXMLSingle(
  xmlId: string,
  respuesta: boolean,
): Promise<void> {
  try {
    const { data } = await client_EB_api.query({
      query: respuesta ? downloadRespXML : queryXML,
      variables: {
        id: xmlId,
      },
    });

    downloadFile(data.resp, `${xmlId}${respuesta ? "-resp" : ""}.xml`);
  } catch (error) {
    customToast.error("Error al descargar el archivo");
  }
}
